import { Component } from "react";
import { useLocation } from "react-router-dom";

class Boundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("Page crashed while rendering:", error);
  }

  componentDidUpdate(prevProps) {
    // Navigating to another page clears the error so one bad page can't
    // leave the rest of the site blank.
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="grid min-h-[60vh] place-items-center px-6 text-center">
        <div>
          <p className="text-2xl font-black text-ink">This page didn&apos;t load properly</p>
          <p className="mt-2 text-sm text-ink/60">Please reload — it usually fixes itself.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-5 inline-flex items-center rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-cream hover:bg-ink/85"
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default function RouteErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <Boundary resetKey={pathname}>{children}</Boundary>;
}
